import { HttpErrorResponse } from '@angular/common/http';
import { ApiException, ApiExceptionConstructor } from 'src/core/common/domain/exceptions/api-exception';

export class MasterDataStructureInvalidException extends ApiException implements ApiExceptionConstructor {
  constructor(message?: string, error?: HttpErrorResponse | Error) {
    super(message, error);
    this.name = 'MasterDataStructureInvalidException';
  }

  static fromError(error: HttpErrorResponse | Error): MasterDataStructureInvalidException {
    return new this(error.message, error);
  }
}
